import React from 'react';
import ReactDOM from 'react-dom';
import { parsePrice } from '../../../lib/helper.js';
import { filterItemModifier } from '../../dashboard/actions/cartActions.js';
import { OUT_OF_STOCK, OUT_OF_STOCK_LEVELS } from '../../../util/Constants';
import OutOfStockLable from '../../inventory/components/OutOfStockLable';
import { includes, get } from "lodash";
import { getSelectedPizzaCreatorModifiers } from "../../dashboard/components/items/components/PizzaCreatorModifiers/utils";
import PizzaCreatorOrderModifiers from "./PizzaCreatorOrderModifiers"

const NOT_AVAILABLE = 'Not Available';

export const ShowModifier = props => {
  let strikeStyles = { color: 'red' };
  return (
    <div className="row fluid-row">
      <div className="col-xs-12">
        {props.strike || props.ingredient.availability === OUT_OF_STOCK ? (
          <span>
            <strike
              className="order-panel-item-modifier-name"
              style={strikeStyles}
            >
              - {props.ingredient.title}
              {parseFloat(parsePrice(props.ingredient.cost, true)) ? (
                <span
                  className="order-panel-item-modifier-name"
                  style={strikeStyles}
                >
                  {' '}
                  ( {parsePrice(props.ingredient.cost)} ){' '}
                </span>
              ) : null}
            </strike>
            {props.ingredient.availability === OUT_OF_STOCK ? (
              <span
                className="order-panel-item-modifier-name"
                style={strikeStyles}
              >
                &nbsp;(
                {props.ingredient.availability})
              </span>
            ) : null}
          </span>
        ) : (
          <span className="order-panel-item-modifier-name">
            - {props.ingredient.title}
            {parseFloat(parsePrice(props.ingredient.cost, true)) ? (
              <span className="order-panel-item-modifier-name">
                {' '}
                ( {parsePrice(props.ingredient.cost)} ){' '}
              </span>
            ) : null}
          </span>
        )}
      </div>
    </div>
  );
};

export const ItemModifiers = props => {
  return (
    <div>
      {Object.keys(props.cookedItems).map(key => {
        let modifiers = [];
        if (props.cookedItems[key].selectedModifiers) {
          modifiers.push(
            Object.keys(props.cookedItems[key].selectedModifiers).map(
              selectedkey => {
                return (
                  <ShowModifier
                    key={key + Math.random()}
                    strike={false}
                    ingredient={
                      props.cookedItems[key].selectedModifiers[selectedkey]
                    }
                  />
                );
              }
            )
          );
        }
        return modifiers;
      })}
    </div>
  );
};

class Accordion extends React.Component {
  constructor() {
    super();
    this.state = {
      active: false,
      expandList: false,
      cookedItems: {},
    };
    this.toggle = this.toggle.bind(this);
    this.expandList = this.expandList.bind(this);
  }

  switchModal(clickedItem) {
    this.props.switchModal(clickedItem);
  }
  updateCartItem(clickedItem, orderItemIndex) {
    this.props.updateCartItem(clickedItem, orderItemIndex, true);
  }
  removeOrderItem(itemIndex) {
    this.props.removeOrderItem(itemIndex);
  }
  toggle() {
    this.setState({
      active: !this.state.active,
    });
  }

  expandList() {
    this.setState({
      expandList: !this.state.expandList,
    });
    let node = ReactDOM.findDOMNode(this.refs.btn);
    this.props.expandItemList(node);
  }

  switchEditModal(index) {
    this.props.switchEditModal(this.props.itemDetails, index);
  }

  componentWillReceiveProps(nextProps) {
    const selectedModifiers = this.getSelectedItemsList(
      nextProps.itemDetails,
      true
    );
    this.setState({
      cookedItems: selectedModifiers,
    });
  }

  getSelectedItemsList(itemDetails) {
    let cookedItems = {};
    //If this item use Pizza Creator, we have to take the modifiers from there
    if(itemDetails.use_pizza_creator)
      cookedItems = getSelectedPizzaCreatorModifiers(get(itemDetails, 'pizza_creator.pizza_mods', []));
    else {
      if (itemDetails.forced) {
        cookedItems = Object.assign(
          cookedItems,
          filterItemModifier({
            i: itemDetails.forced,
            r: cookedItems,
          }).r
        );
      }
      if (itemDetails.optional) {
        cookedItems = Object.assign(
          cookedItems,
          filterItemModifier({
            i: itemDetails.optional,
            r: cookedItems,
          }).r
        );
      }
    }
    return cookedItems;
  }

  render() {
    const { itemDetails, itemIndex } = this.props;
    const cookedItems = this.getSelectedItemsList(itemDetails);
    const actionEdit = (
      <img
        className="cursonPointer no-selection"
        onClick={() =>
          this.updateCartItem(itemDetails, itemIndex)
        }
        src={require('../../../public/images/edit_menuItem.png')}
        alt=""
      />
    );

    let item;
    if (
      itemDetails.availability === NOT_AVAILABLE ||
      includes(OUT_OF_STOCK_LEVELS, itemDetails.notavailable)
    ) {
      item = (
        <span>
          <strike style={{ color: 'red' }}>
            {itemDetails.name}
          </strike>
          <OutOfStockLable
            right={false}
            notavailable={itemDetails.notavailable}
          />
        </span>
      );
    } else {
      item = (
        <span>
          {itemDetails.name + ' '}
          {actionEdit}
        </span>
      );
    }

    let specialInstruction = itemDetails.specialInstruction;
    if (specialInstruction) {
      specialInstruction = (
        <span className="special-instruction">{specialInstruction}</span>
      );
    }
    return (
      <li className="list-group-item ">
        <div
          ref="btn"
          className="row toggle"
          id={`dropdown-detail-${itemIndex}`}
          data-toggle={`detail-${itemIndex}`}
        >
          <div
            className="col-xs-1"
            onClick={() => this.removeOrderItem(itemIndex)}
          >
            <img
              className="cursonPointer no-selection"
              src={require('../../../public/images/delete_menuItem.png')}
              alt=""
            />
          </div>
          <div
            className="col-xs-7 order-panel-item-name order-panel-modifier-align olo-client-theme-color"
            style={{ paddingLeft: '5px' }}
          >
            {item}
          </div>

          <div className="col-xs-2 order-panel-item-price order-panel-modifier-align">
            {parsePrice(itemDetails.price)}
          </div>
          {Object.keys(cookedItems).length !== 0 || specialInstruction ? (
            this.state.expandList ? (
              <div
                className="col-xs-1 order-panel-modifier-align"
                onClick={this.expandList}
              >
                <span
                  className="cursonPointer no-selection glyphicon glyphicon-chevron-up olo-client-theme-color"
                  style={{ color: '#7DA000' }}
                />
              </div>
            ) : (
              <div
                className="col-xs-1 order-panel-modifier-align"
                onClick={this.expandList}
              >
                <span
                  className="cursonPointer no-selection glyphicon glyphicon-chevron-down olo-client-theme-color"
                  style={{ color: '#7DA000' }}
                />
              </div>
            )
          ) : null}
        </div>
        <div
          style={{ display: 'none' }}
          id={`dropdown-detail-${itemIndex}-list`}
        >
          <div className="row">
            <div className="col-md-12"> {specialInstruction} </div>
          </div>
          { itemDetails.use_pizza_creator ?
            <PizzaCreatorOrderModifiers modifiers={cookedItems} /> : 
            <ItemModifiers cookedItems={cookedItems} /> }
        </div>
      </li>
    );
  }
}
export default Accordion;



// WEBPACK FOOTER //
// ./src/views/common/OrderPanel/Accordion.jsx